import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import type {
  CoworldSwitcherRow as Row,
  CoworldSwitcherLinkProps,
} from "./coworld-switcher-types";
import { stepSwitcherRows } from "./step-switcher-rows";
import { styles } from "./coworld-switcher-rows.styles";

export function CoworldSwitcherRow({
  row,
  renderLink,
  onOpenChange,
}: {
  readonly row: Row;
  readonly renderLink: (props: CoworldSwitcherLinkProps) => ReactNode;
  readonly onOpenChange: (open: boolean) => void;
}) {
  return (
    <div>
      {renderLink({
        href: row.href,
        "data-switcher-row": "",
        onClick: () => onOpenChange(false),
        onKeyDown: stepSwitcherRows,
        ...stylex.props(styles.row, row.kind === "league" && styles.league),
        children: (
          <>
            <span {...stylex.props(row.current && styles.current)}>
              {row.name}
            </span>
            {row.kind === "coworld" && !row.member ? (
              <span {...stylex.props(styles.member)}>not a member</span>
            ) : null}
          </>
        ),
      })}
    </div>
  );
}
